export const workflow = 'workflow';
export const terminal = 'terminal';
export const hierarchyConfigurator = 'hierarchy-configurator';
export const userManagement = 'user-management';
export const processdataCollection = 'processdata-collection';
export const cockpit = 'cockpit';
export const shiftManagement = 'shift-management';
export const platformConfigurator = 'platform-configurator';
export const customActions = 'custom-actions';
export const orderManagement = 'order-management';
export const materialManagement = 'material-management';
export const personnelManagement = 'personnel-management';
export const documentManagement = 'document-management';
export const collaboration = 'collaboration';
export const performanceAnalysis = 'performance-analysis';
export const taskManagement = 'task-management';
export const eventLog = 'event-log';
export const reportLog = 'report-log';
export const transition = 'transition';
export const workflowCorrection = 'workflow-corrections';
export const unrestricted = 'unrestricted';
export const superUser = 'super-user';
export const operationAbort = 'operation-abort';
export const interruptionClassification = 'interruption-classification';
export const taskActivation = 'task-activation';
export const specialTaskManagement = 'special-task-management';
export const batchHandling = 'batch-handling';
export const office = 'office';

export class Scope {
  /**
   * @param scope string containing both right and scope in the form of "right:scope" e.g. "read:operations"
   */
  constructor(scope) {
    [this.right, this.name] = scope.split(':');
  }

  name = null;
  right = null;
}
